var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcLogoKakao = function SvgIcLogoKakao(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 10.91c-.012-3.928 4.009-7.122 8.978-7.137 4.972-.014 9.01 3.16 9.022 7.081.012 3.928-4.01 7.122-8.978 7.137a11.4 11.4 0 0 1-1.619-.11l-3.64 2.474a.26.26 0 0 1-.406-.284l.838-3.171C4.68 15.647 3.009 13.433 3 10.91"
  })));
};
export default SvgIcLogoKakao;